import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
import { roleColumns } from './_columns'
import CouponAnalyticsDashboard from '../CouponsSupplyChain/Couponanalyticsdashboard'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import { useAuth } from '../../../../auth'

const UsersList = () => {
  const { itemIdForUpdate } = useListView()
  const { responseData: voucherAnalytics } = useFetchCommon({
    api: `analytics/vouchers`,
    isDropDown: false,
  })
  const { currentUser } = useAuth() as any;
  return (
    <KTCard>
      <CouponAnalyticsDashboard analyticsData={voucherAnalytics} />
      {currentUser?.userType !== "CLIENT" && <UsersListHeader placeholder='Search Sponsor' label='Add' />}
      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName='CouponsModalForm' />
    </KTCard>
  )
}

const CouponsWrapper = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'coupons' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { CouponsWrapper }
